export default __webpack_public_path__ + "6a3067e831400f82c12e458df7de3c19.png";